import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import ThemeContext from '../../providers/ThemeProvider';

const MainDealReviewsPagination = ({
  openedPage,
  itemsPerPage,
  onPageChange,
  totalItems,
}) => {
  const theme = useContext(ThemeContext);
  const [currentPage, setCurrentPage] = useState(openedPage);

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (typeof onPageChange === 'function') onPageChange(page);
  };

  return (
    <>
      <div className="pagination">
        <span className="pagination-text">
          Page: {currentPage} of {totalPages}
        </span>{' '}
        <button
          className="prev-btn"
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
          type="button"
        >
          {'<'}
        </button>{' '}
        <button
          className="next-btn"
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
          type="button"
        >
          {'>'}
        </button>
      </div>
      <style jsx>{`
        .pagination {
          display: flex;
          align-items: center;
          margin: 10px 0;
        }

        .prev-btn,
        .next-btn {
          padding: 5px 10px;
          margin: 0 5px;
          background-color: ${theme.colors.primary};
          color: ${theme.commoncolors.white};
          border: none;
          border-radius: 4px;
          cursor: pointer;
        }

        .prev-btn:disabled,
        .next-btn:disabled {
          background-color: ${theme.commoncolors.greypastel};
          cursor: not-allowed;
        }

        .pagination-text {
          margin-right: 10px;
        }
      `}</style>
    </>
  );
};

MainDealReviewsPagination.propTypes = {
  itemsPerPage: PropTypes.number,
  onPageChange: PropTypes.func,
  openedPage: PropTypes.number,
  totalItems: PropTypes.number,
};

export default MainDealReviewsPagination;
